module.exports = __webpack_public_path__ + "img/sp_eyecatch01.cc728c6b.png";